module.exports = __webpack_public_path__ + "img/tip.68982db8.png";